
/*
  This component will display selectbox in configurator
 */

import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';

const ExceptionMessage = (props) => {
    const message = props.message.join(", ");
    const [arrowLeft, setArrowLeft] = useState("");

    useEffect(() => {
        const windowWidth = window.innerWidth;
        const maxWindowSizeForLeft = 0.66;
        setArrowLeft((props.posLeft < (windowWidth * maxWindowSizeForLeft)));
    })

    const getPositionStyle = () => {
        let style;

        if(arrowLeft){
            // leftPos = X - ((100vw - 100%) / 2 - 20px
            // 100vw - 100%  / 2 removes the side padding around the app, the -20px is to adjust the position a bit.
            style = {left: 'calc(' + props.posLeft + 'px - ((100vw - 100%) / 2) - 20px)'};
        } else {
            style = {left: 'calc((' + props.posLeft + 'px * 0.44) - ((100vw - 100%) / 2) - 20px)'};
        }

        if(props.posTop) {
            style.top = props.posTop + 'px';
            // style.position = 'absolute';
        }
        return style;
    }
    return (
        <div className={"configurator-reason show-on-desktops " + (arrowLeft ? '':"from-right")} style={getPositionStyle()}>
            <div className="row">
                <div className="three columns"></div>
                <div className="nine columns">
                    <span className="exception-reason">{message}</span>
                </div>
            </div>
        </div>
    )
}

ExceptionMessage.props = {
    posLeft: PropTypes.string.isRequired,
    posTop: PropTypes.string,
    message: PropTypes.string
}

export default ExceptionMessage;